<script>
    /**
     * 标签
     */
    export default {
        name: 'check-box',
        props: {
            theme: {
                default: 'grey',
                required: false
            },
            label: {},
            checked: {
                default: false,
                required: false
            },
            icon: {
                default: '',
                required: false
            },
            text: {
                default: '',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            textWidth: {
                default: -1,
                required: false
            }
        },
        data () {
            return {
                selfChecked: this.checked
            };
        },
        model: {
            prop: 'checked',
            event: 'check'
        },
        methods: {
            click () {
                if (!this.isDisabled) {
                    this.toggle();
                }
            },
            toggle () {
                this.isChecked = !this.isChecked;
            }
        },
        watch: {
            checked (v) {
                if (this.isChecked === v) {
                    return;
                }
                this.isChecked = v;
            }
        },
        computed: {
            isChecked: {
                get () {
                    return (this.isGroup ? this._checkboxGroup.getChildChecked(this.label) : false) || this.selfChecked;
                },
                set (val) {
                    if (this.isGroup) {
                        this._checkboxGroup.handleFromChildren(this.label, val);
                    }
                    this.selfChecked = val;
                    this.$emit('check', val);
                }
            },
            isDisabled () {
                return (this.isGroup ? this._checkboxGroup.disabled : false) || this.disabled;
            },
            isGroup () {
                let parent = this.$parent;
                while (parent) {
                    if (parent.$options.componentName !== 'CheckBoxGroup') {
                        parent = parent.$parent;
                    } else {
                        if (parent.data) {
                            return false;
                        }
                        this._checkboxGroup = parent;
                        this.selfChecked = parent.getChildChecked(this.label);
                        if (this.$util.validate.isEmpty(this.label) && !parent.data) {
                            throw Error('使用checkbox-group时必须指定checkbox的label属性');
                        }
                        return true;
                    }
                }
                return false;
            },
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            },
            widthStyle () {
                return {
                    width: this.textWidth === -1 ? 'auto' : `${this.textWidth}px`
                };
            }
        },
        mounted () {

        }
    };
</script>

<template>
    <label class="check-box"
           :class="[theme, {disabled: isDisabled}]"
           :style="curStyle"
    >
        <span class="check" :class="[{checked : selfChecked }]">
            <input class="check-box__original"
                   type="checkbox"
                   :disabled="isDisabled"
                   v-model="isChecked">
            <span v-show="selfChecked">
                &#xe695;
            </span>
        </span>
        <span class="label" v-bind:style="widthStyle" v-show="icon.length > 0 || text.length > 0">
            <span class="icon" v-show="icon.length > 0" v-html="icon"></span>
            <span class="text" v-show="text.length > 0" v-html="text"></span>
        </span>
        <span v-if="!icon.length && !text.length" class="label">
            <slot></slot>
        </span>
    </label>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .check-box {
        width: auto;
        min-width: 1px;
        height: @widgetsHeight;
        text-align: center;
        overflow: hidden;
        padding: 0;
        margin: (@lineHeight - @widgetsHeight)/2 0;
        position: relative;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        &__original {
            opacity: 0;
            outline: 0;
            position: absolute;
            margin: 0;
            width: 0;
            height: 0;
            z-index: -1;
        }

        &.circle {
            > .check {

                &.checked {
                    background-color: @primaryBg;
                }
            }
        }

        &.disabled {
            > .check {
                background-color: @otherDisabledBgClr !important;
                border-color: @otherBtnBorderNoteClr !important;
                color: @otherTextClr !important;
            }
        }

        > .check {
            box-sizing: border-box;
            height: 16px;
            width: 16px;
            margin: 10px 0;
            float: left;
            font-size: 12px;
            font-family: cmsicon;
            text-align: center;
            line-height: 16px;
            overflow: hidden;
            background-color: @whiteBg;
            transition: all 0.2s ease-in-out;
        }

        > .label {
            width: auto;
            height: @widgetsHeight;
            line-height: @widgetsHeight;
            min-width: 1px;
            overflow: hidden;
            float: left;
            font-size: 14px;
            margin: 0 8px;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: left;
        }
    }

    .check-box.grey {
        > .check {
            border-radius: 3px;
            border: 1px @otherBtnBorderNoteClr solid;
            color: @otherNormalTitleClr;

            &.checked {
                font-size: 14px;
                color: @whiteBg;
                border-color: @primaryBorderColor;
                background-color: @primaryBg;
            }
        }

        &.circle {
            > .check {
                border-radius: 16px;
                color: @whiteBg;
            }
        }

    }


</style>
